import { render, staticRenderFns } from "./ISAStatreponseTime.vue?vue&type=template&id=495f7372&scoped=true&"
import script from "./ISAStatreponseTime.vue?vue&type=script&lang=js&"
export * from "./ISAStatreponseTime.vue?vue&type=script&lang=js&"
import style0 from "./ISAStatreponseTime.vue?vue&type=style&index=0&id=495f7372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495f7372",
  null
  
)

export default component.exports